/* This file is autogenerated, see readme.md for instructions */
import MobileImageMessageSvgIcon from '@bloomreach/banana-theme/icons/mobile-image-message.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MobileImageMessageIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MobileImageMessageSvgIcon />
    </Icon>
  );
});

MobileImageMessageIcon.displayName = 'MobileImageMessageIcon';

export default MobileImageMessageIcon;
